import Vue from 'vue'
import ViewUI from 'view-design'

import '../iview-variables.less'

Vue.use(ViewUI)
